import * as React from "react";
import { InfoDialogOptions, InfoDialog } from '../../container/InfoDialog';

const InfoDialogContext = React.createContext<
  (options: InfoDialogOptions) => Promise<void>
>(Promise.reject);

export const useInfoDialog = () =>
  React.useContext(InfoDialogContext);

export const InfoDialogProvider = ({ children }: { children: any }) => {
  const [
    InfoDialogState,
    setInfoDialogState
  ] = React.useState<InfoDialogOptions | null>(null);

  const awaitingPromiseRef = React.useRef<{
    resolve: () => void;
    reject: () => void;
  }>();

  const openInfoDialog = (options: InfoDialogOptions) => {
    setInfoDialogState(options);
    return new Promise<void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (InfoDialogState?.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    setInfoDialogState(null);
  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setInfoDialogState(null);
  };

  return (
    <>
      <InfoDialogContext.Provider
        value={openInfoDialog}
        children={children}
      />

      <InfoDialog
        open={Boolean(InfoDialogState)}
        onSubmit={handleSubmit}
        onClose={handleClose}
        {...InfoDialogState}
      />
    </>
  );
};
